/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteRemoteMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteRemoteMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteRemoteMcpServerSecurity = {
  option1?: DeleteRemoteMcpServerSecurityOption1 | undefined;
  option2?: DeleteRemoteMcpServerSecurityOption2 | undefined;
};

export type DeleteRemoteMcpServerRequest = {
  /**
   * The ID of the remote MCP server to delete
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteRemoteMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteRemoteMcpServerSecurityOption1$outboundSchema: z.ZodMiniType<
  DeleteRemoteMcpServerSecurityOption1$Outbound,
  DeleteRemoteMcpServerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteRemoteMcpServerSecurityOption1ToJSON(
  deleteRemoteMcpServerSecurityOption1: DeleteRemoteMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    DeleteRemoteMcpServerSecurityOption1$outboundSchema.parse(
      deleteRemoteMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteRemoteMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteRemoteMcpServerSecurityOption2$outboundSchema: z.ZodMiniType<
  DeleteRemoteMcpServerSecurityOption2$Outbound,
  DeleteRemoteMcpServerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function deleteRemoteMcpServerSecurityOption2ToJSON(
  deleteRemoteMcpServerSecurityOption2: DeleteRemoteMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    DeleteRemoteMcpServerSecurityOption2$outboundSchema.parse(
      deleteRemoteMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteRemoteMcpServerSecurity$Outbound = {
  Option1?: DeleteRemoteMcpServerSecurityOption1$Outbound | undefined;
  Option2?: DeleteRemoteMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteRemoteMcpServerSecurity$outboundSchema: z.ZodMiniType<
  DeleteRemoteMcpServerSecurity$Outbound,
  DeleteRemoteMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteRemoteMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteRemoteMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteRemoteMcpServerSecurityToJSON(
  deleteRemoteMcpServerSecurity: DeleteRemoteMcpServerSecurity,
): string {
  return JSON.stringify(
    DeleteRemoteMcpServerSecurity$outboundSchema.parse(
      deleteRemoteMcpServerSecurity,
    ),
  );
}

/** @internal */
export type DeleteRemoteMcpServerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteRemoteMcpServerRequest$outboundSchema: z.ZodMiniType<
  DeleteRemoteMcpServerRequest$Outbound,
  DeleteRemoteMcpServerRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteRemoteMcpServerRequestToJSON(
  deleteRemoteMcpServerRequest: DeleteRemoteMcpServerRequest,
): string {
  return JSON.stringify(
    DeleteRemoteMcpServerRequest$outboundSchema.parse(
      deleteRemoteMcpServerRequest,
    ),
  );
}
